var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 9.75676C19 4.36829 14.7467 0 9.5 0C4.25334 0 0 4.36829 0 9.75676C0 14.3323 3.06736 18.1718 7.20518 19.2263V12.7384H5.24628V9.75676H7.20518V8.47199C7.20518 5.15118 8.66856 3.61195 11.8431 3.61195C12.445 3.61195 13.4835 3.73333 13.9084 3.85431V6.55693C13.6842 6.53273 13.2947 6.52064 12.8109 6.52064C11.2533 6.52064 10.6514 7.12673 10.6514 8.70225V9.75676H13.7545L13.2213 12.7384H10.6514V19.4421C15.3554 18.8586 19.0004 14.7452 19.0004 9.75676H19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.221 12.7384L13.7541 9.75674H10.651V8.70223C10.651 7.12671 11.253 6.52062 12.8106 6.52062C13.2943 6.52062 13.6838 6.53272 13.908 6.55692V3.8543C13.4832 3.73292 12.4446 3.61194 11.8427 3.61194C8.66819 3.61194 7.20481 5.15116 7.20481 8.47197V9.75674H5.24591V12.7384H7.20481V19.2263C7.93973 19.4136 8.70847 19.5135 9.49963 19.5135C9.88913 19.5135 10.2733 19.4889 10.6507 19.4421V12.7384H13.2206H13.221Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19.5135,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.899d556970712d19f6c8cd520cb9c59c.svg";
export { ForwardRef as ReactComponent };